module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard', {
    attrs: {
      "results": _vm.searchProfile,
      "searching": this.$apollo.queries.searchProfile.loading,
      "loading-profile": _vm.loadingProfile
    },
    on: {
      "search-profile": _vm.handleSearchQuery,
      "display-profile": _vm.handleDisplayProfile
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a885892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/permission/PermissionsDashboardContainer.vue
// module id = 3229
// module chunks = 3